import React, { useEffect, useState } from "react";
import { customFieldMetadataItem, setCustomFieldsMetadata } from "../../redux/customFields/customFieldsSlice";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { selectCurrentUserId } from "../../redux/auth/authSlice";
import { Dropdown, Table } from "react-bootstrap";
import ItemListingTitle from "../../components/itemListingTitle/itemListingTitle";
import { ReactSVG } from "react-svg";
import threedotvertical from "../../assets/images/three-dots-vertical.svg";
import editicon from "../../assets/images/edit-icon.svg";
import viewicon from "../../assets/images/view-icon.svg";
import deactivateicon from "../../assets/images/deactivate-icon.svg";
import deleteicon from "../../assets/images/delete-icon.svg";
import duplicateicon from "../../assets/images/duplicate-icon.svg";
import { useNavigate } from "react-router-dom";
import useCustomFields from "../../Hooks/useCustomFields";
import Loading from "../../components/LoadingPage/Loading";
import { DeleteConfModel } from "../../components/DeleteConfModel/deleteConfModel";

const CustomFieldsManagement = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const defaultCustomFields = useAppSelector(customFieldMetadataItem);
  const currentUserId = useAppSelector(selectCurrentUserId);
  const [customFieldList, setCustomFieldList] = React.useState<any>(defaultCustomFields ?? []);
  const defaultFilter = { searchText: "", active: true };
  const [searchFieldVal, setSearchFieldVal] = useState(defaultFilter);
  const [currentField, setCurrentField] = useState<any>(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const {
    getCustomFieldsMetadataAPI,
    getCustomFieldsMetadataLoading,
    editCustomFieldsMetadataAPI,
    editCustomFieldsMetadataLoading,
    deleteCustomFieldsMetadataAPI,
    deleteCustomFieldsMetadataLoading,
    duplicateCustomFieldsMetadataAPI,
    duplicateCustomFieldsMetadataLoading,
  } = useCustomFields();

  const fetchCustomFieldsList = async () => {
    try {
      const res = await getCustomFieldsMetadataAPI({});
      setCustomFieldList(res);
      dispatch(setCustomFieldsMetadata(res));
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCustomFieldsList();
  }, []);

  const toggleDeleteModal = () => {
    setShowDeleteModal(!showDeleteModal);
  };

  const handleView = (item: any) => {
    navigate(`/view-custom-fields/${item.id}`);
  };

  const handleEdit = (item: any) => {
    navigate(`/edit-custom-fields/${item.id}`);
  };

  const handleToggleStatus = async (item: any) => {
    await editCustomFieldsMetadataAPI({
      ...item,
      controlTypeId: item?.controlType?.id,
      dataTypeId: item?.datatype?.id,
      moduleId: item?.customFieldModule?.id,
      isActive: !item.isActive,
      updatedBy: currentUserId ?? "",
    });
    fetchCustomFieldsList();
  };

  const handleDelete = async () => {
    await deleteCustomFieldsMetadataAPI({
      id: currentField?.id,
      updatedBy: currentUserId ?? "",
    });
    toggleDeleteModal();
    fetchCustomFieldsList();
  };

  const handleDuplicate = async (item: any) => {
    await duplicateCustomFieldsMetadataAPI({
      id: item?.id,
      createdBy: currentUserId ?? "",
    });
    fetchCustomFieldsList();
  };

  return (
    <div className="user-listing-wrapper">
      {getCustomFieldsMetadataLoading ||
        editCustomFieldsMetadataLoading ||
        deleteCustomFieldsMetadataLoading ||
        duplicateCustomFieldsMetadataLoading ? (
        <Loading />
      ) : null}
      <ItemListingTitle
        title="Custom Fields Master"
        buttonTitle="Add New"
        href="/create-custom-fields"
        disRecords={customFieldList?.length || 0}
        totalRecords={customFieldList?.length || 0}
        searchVal={searchFieldVal}
        setSearchVal={setSearchFieldVal}
        defaultFilter={defaultFilter}
        isAddPermitted={true}
      />
      <div className="listing-table-wrapper">
        <Table responsive="md" hover={true}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Control Type</th>
              <th>Data Type</th>
              <th>Default Value</th>
              <th>Module</th>
              <th>Is Required</th>
              <th>Is Active</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {customFieldList?.map((x: any) => (
              <tr
                key={x?.id}
              >
                <td>{x?.name}</td>
                <td>{x?.controlType?.name}</td>
                <td>{x?.datatype?.name}</td>
                <td>{x?.defaultValue ?? "-"}</td>
                <td>{x?.customFieldModule?.name}</td>
                <td>
                  {x?.isRequired ? "Yes" : "No"}
                </td>
                <td>
                  <span
                    className={`status-circle ${x?.isActive ? "active" : "inactive"}`}
                  >
                    {x?.isActive ? "Active" : "Inactive"}
                  </span>
                </td>
                <td>
                  <Dropdown>
                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                      <ReactSVG
                        className="svg-box"
                        wrapper="span"
                        src={threedotvertical}
                      />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item
                        onClick={() => handleView(x)}
                      >
                        <ReactSVG
                          className="svg-box"
                          wrapper="span"
                          src={viewicon}
                        />
                        View
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => handleToggleStatus(x)}
                      >
                        <ReactSVG
                          className="svg-box"
                          wrapper="span"
                          src={deactivateicon}
                        />
                        {x.isActive ? "Deactivate" : "Activate"}
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => handleEdit(x)}
                      >
                        <ReactSVG
                          className="svg-box"
                          wrapper="span"
                          src={editicon}
                        />
                        Edit
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => handleDuplicate(x)}
                      >
                        <ReactSVG
                          className="svg-box"
                          wrapper="span"
                          src={duplicateicon}
                        />
                        Duplicate
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => {
                          setCurrentField(x);
                          toggleDeleteModal();
                        }}
                      >
                        <ReactSVG
                          className="svg-box"
                          wrapper="span"
                          src={deleteicon}
                        />
                        Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <DeleteConfModel
        showModal={showDeleteModal}
        toggleModal={toggleDeleteModal}
        deleteAction={handleDelete}
        modelName={`Custom Field`}
        recordName={currentField?.name || ""}
      />
    </div>
  );
}
export default CustomFieldsManagement;

